module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAUCAYAAADoZO9yAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEFSURBVEhLvdJPDsFAFIDxmTbYOoKNpHauIHEAbsDJuIG9EG7A0tIR7ERFyjeG1J/qzGvrS8q8WrxfG+pRex537fFvpXcGfETLeBQGahMt4om5+4fYZXbedjPrzuI0SJSemV/vTXf9+tieK8k+sAGQVskwOIb1daLU1t6jUZVv5h3BbgyaobVKmo3LeXUb0v+T0t/MN8QprPX2PX0wEKoa8wvB/IRQVZg8BL1AqGyMC4I+IFQWxhVBXyFUFOODoEwISTG+CPoJIV+MBEG5EHLFSBHkBKE8TBEEOUMoC2O/xQjyglAG5pkEQd4QysJIESSC0DumCILEEHpgOBdBlBIYLjsKU+oKROTxKVt+VvYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/down-carot-large.png
// module id = 1814
// module chunks = 0